<template>
    <div class="nav-item" :class="{'active': active}" @click="openUnavailablePopup">
        <modal v-if="popup_open && popup_name === 'board_unavailable'" modal_name="board_unavailable" type="medium" :title="translations['membership.no_access_title']" icon="lock">
            <template v-slot:modal-content>
                <div class="tw-mb-1">
                    <template v-if="board.salespage === ''">
                        <p v-if="!user" class="light-text" style="margin-bottom: 10px;" v-text="translations['membership.login_to_access_caption']"></p>
                        <p v-else class="light-text" style="margin-bottom: 10px;" v-text="translations['membership.no_proper_levels']"></p>
                    </template>
                    <template v-else>
                        <p class="light-text" style="margin-bottom: 10px;">{{ translations['membership.no_access_caption'] }} </p>

                        <p class="light-text">{{ translations['membership.does_have_access'] }} <a href='/auth/login' class='secondary-c bold-text'>{{ translations['membership.click_to_login'] }}.</a></p>
                    </template>
                </div>
            </template>
            <template v-slot:modal-bottom>
                <div class="subtle-button slim" @click="closePopup">
                    {{ translations['fields.close'] }}
                </div>
                <a :href="board.salespage === '' ? '/auth/login#login' : board.salespage" target="_blank" class="general-button btn-v2 slim">
                    <template v-if="board.salespage === '' && !user">
                        {{ translations['navigation.login'] }}
                    </template>
                    <template v-else>
                        {{ translations['membership.get_access'] }}
                    </template>
                    <i class="fa fa-sign-in"></i>
                </a>
            </template>
        </modal>

        <a :class="{'unavailable-board': !available}"
           class="mainboard"
           :href="boardUrl">
            <i v-if="!available" class="far fa-lock tw-mr-2 tw-mt-1"></i>
            <li :class="{'active-channel':active}"
                class="board-navigation-item"
                :data-id="board.id">
                {{ board.name }}
            </li>
            <span v-if="available"
                  class="notification-count hidden notification-badge"
                  :data-notify-id="'community.boards.' + board.slug"
                  :data-notify-ids="subboardNotifyIds"></span>
        </a>
        <div class="tw-flex tw-items-center">
            <a :href="boardId === board.id ? '/' : boardUrl" class="subboards-back-btn hidden" v-if="active">
                <i class="subboards-back-btn far fa-angle-left simple-hover normal-text"></i>
            </a>
            <div class="sub-channels-wrapper light-text small-text" v-if="subboards.length > 0 && active">
                <nav-sub-board v-for="subboard in subboards"
                               :key="subboard.id"
                               :subboard="subboard"
                               :board="board"
                               :main_board_active="boardId === board.id"></nav-sub-board>
            </div>
        </div>
    </div>
</template>
<script>
    import orderBy from 'lodash.orderby';
    import Global from '../../../mixins/Global';
    import Modal from '../../../mixins/v2/Modal';
    import NavSubBoard from './NavSubBoard.vue';

    export default {
        name: 'NavBoard',

        mixins: [Global, Modal],

        components: {
            'nav-sub-board': NavSubBoard
        },

        props: {
            board: {
                required: true,
                type: Object,
            },
            boards: {
                type: Array,
            },
        },

        data() {
            return {
                boardId,
            }
        },

        computed: {
            available() {
                return this.board.permissions.includes('READ');
            },

            boardUrl() {
                if (this.available) {
                    return '/boards/' + this.board.slug;
                }

                return '#';
            },

            subboardNotifyIds() {
                let subboard_notify_ids = '';

                for (let i = 0; i < this.subboards.length; i += 1) {
                    subboard_notify_ids += 'community.boards.' + this.subboards[i].slug + ',';
                }

                subboard_notify_ids = subboard_notify_ids.slice(0, -1);

                return subboard_notify_ids;
            },

            subboards() {
                if (!this.boards) return [];

                const ordered_boards = orderBy(this.boards, 'index');

                return ordered_boards.filter(board => (board.subgroup_id === this.board.id && board.permissions.includes("READ")));
            },

            active() {
                let subboard_active = false;

                if (this.board.id === this.boardId) {
                    return true;
                }

                this.subboards.forEach((subboard) => {
                    if (subboard.id === this.boardId){
                        subboard_active = true;
                    }
                })

                return subboard_active;
            }
        },

        methods: {
            openUnavailablePopup() {
                if (!this.available) {
                    this.openPopup('board_unavailable');
                }
            },
        },
    };
</script>